import { injectGlobal } from '@bd/bdui-styles/emotion';

injectGlobal(`
  @media (min-width: 1600px) {
    .container {
      max-width: 1400px;
    }
  }
  .btn {
    background-color: #c6cc27;
    transition: all .3s ease;
    color: #111111;
    padding: 15px 25px;
    font-weight: 700;
    border-radius: 50px;
    text-transform: uppercase;
    &:hover {
      background-color: #c6cc27;
    }
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js